<script setup>
import { computed } from 'vue';

const props = defineProps({
  tone: {
    type: String,
    default: 'slate',
    validator: value =>
      ['slate', 'blue', 'teal', 'amber', 'ruby'].includes(value),
  },
  dot: {
    type: Boolean,
    default: false,
  },
});

const TONES = {
  slate: { pill: 'bg-n-alpha-2 text-n-slate-11', dot: 'bg-n-slate-9' },
  blue: { pill: 'bg-n-brand/10 text-n-blue-11', dot: 'bg-n-brand' },
  teal: { pill: 'bg-n-teal-9/10 text-n-teal-11', dot: 'bg-n-teal-9' },
  amber: { pill: 'bg-n-amber-9/10 text-n-amber-11', dot: 'bg-n-amber-9' },
  ruby: { pill: 'bg-n-ruby-9/10 text-n-ruby-11', dot: 'bg-n-ruby-9' },
};

const toneClasses = computed(() => TONES[props.tone]);
</script>

<template>
  <span
    class="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2 py-0.5 text-label-small"
    :class="toneClasses.pill"
  >
    <span
      v-if="dot"
      class="rounded-full size-1.5 shrink-0"
      :class="toneClasses.dot"
    />
    <slot />
  </span>
</template>
